import React, { Component } from 'react';
import { Modal } from 'antd';
import FormList from '../basicElement/FormList';
import $ from "../../common/AjaxRequest";
import API_URL from '../../common/url';

class SwitchInvestigation extends Component {
    state = {
        visible: false,
        loading: false,
        roleList: [],
        data: {},
    }

    show = () => {
        const {
            invName, invId, blindType, blindInvId, blindInvName, curRole, investigationSiteCode,
            investigationSiteName, siteId, relatedSiteId, isKeyAccountManager
        } = sessionStorage;
        this.setState({
            visible: true,
            data: {
                blindType,
                blindInvId,
                blindInvName,
                investigationId: invId,
                investigationName: invName,
                roleCode: (isKeyAccountManager === 'true' && curRole == 'TAL') ? 'KAM' : curRole,
                relatedSiteId,
                investigationSiteName: `${investigationSiteName}${investigationSiteCode ? `(${investigationSiteCode})` : ''}`,
                investigationSite: { investigationSiteId: siteId, investigationSiteName, investigationSiteCode, relatedSiteId },
            },
        }, () => {
            this.queryRole();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    doSubmit = () => {
        const { data } = this.state;
        const { isKeyAccountManager } = sessionStorage;
        const { investigationId, investigationName, blindType, blindInvId, blindInvName, roleCode, investigationSite } = data;
        const { investigationSiteId, investigationSiteName, investigationSiteCode, relatedId } = investigationSite || {};
        this.setState({ visible: false }, () => {
            this.props.onChange({
                curRole: (isKeyAccountManager === 'true' && roleCode == 'KAM') ? 'TAL' : roleCode,
                blindType,
                blindInvId,
                blindInvName,
                invId: investigationId,
                invName: investigationName,
                siteId: investigationSiteId,
                relatedSiteId: relatedId || '',
                investigationSiteName: investigationSiteName,
                investigationSiteCode: investigationSiteCode || ''
            });
        });
    }

    queryRole= () => {
        const { data: { investigationId } } = this.state;
        const options = {
            url: API_URL.user.getRoleListForInvestigation,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data: { roles } } = res;
                // const roleList = (roles || []).map(i => ({ label: i === 'TAL' ? '领域leader' : i, value: i }));
                const roleList =  (roles || []).map(el => {
                    let text = '';
                    if (el === 'TAL') {
                        text = '领域leader';
                    } else if (el === 'KAM') {
                        text = '大客户经理';
                    } else {
                        text = el;
                    }
                    return {
                        value: el,
                        label: text,
                    }
                })
                this.setState({ roleList });
            },
        };
        $.sendRequest(options);
    }

    handleChange = (value, key, type) => {
        const { data } = this.state;
        if (key === 'investigationName') {
            const { value: id, text: name, blindType, blindInvestigationId, blindInvestigationName } = value;
            data[key] = name;
            data['investigationId'] = id;
            data.blindType = blindType;
            data.blindInvId = blindInvestigationId || '';
            data.blindInvName = blindInvestigationName || '';
            this.setState({ data }, () => {
                this.handleChange(undefined, 'roleCode', 'select');
                value.value && this.queryRole();
            });
        } else if (key === 'roleCode') {
            data[key] = value;
            this.setState({ data }, () => {
                this.handleChange({}, 'investigationSiteName', 'searchRetrieve');
            });
        } else if (key === 'investigationSiteName') {
            data[key] = value.text;
            data['investigationSite'] = value;

            this.setState({ data });
        }
    }

    getColumns = () => {
        const { data, roleList } = this.state;

        // 字段属性配置
        const columns = [{
            name: '项目',
            key: 'investigationName',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'searchKey',
                style: { width: 200 },
                placeholder: '输入项目简称检索',
                params: {limit: 20 },
                url: API_URL.investigation.queryUserInvestigationList,
                config: { id: 'investigationId', name: 'investigationName', type: 'investigation' },
            },
            rules: {
                required: true,
            }
        }, {
            name: '角色',
            key: 'roleCode',
            type: 'select',
            typeProperty: {
                list: roleList,
                style: { width: 200 },
                disabled: !data['investigationId'],
            },
            rules: {
                required: true,
            }
        }, {
            name: '中心',
            key: 'investigationSiteName',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'searchKey',
                style: { width: 200 },
                placeholder: '输入中心名称检索',
                params: {limit: 20, investigationId: data['investigationId'], roleCode: data['roleCode'] === 'KAM' ? 'TAL' : data['roleCode'] },
                disabled: !data['roleCode'],
                url: API_URL.site.queryUserSiteList,
                config: { id: 'investigationSiteId', name: 'investigationSiteName', code: 'investigationSiteCode', type: 'invSite', show: 'invSite' },
            },
            rules: {
                required: true,
            }
        }];

        // 字段值、显示状态配置
        const traverseColumns = function (columns) {
            columns.forEach(column => {
                const { key, type, children, rules = {} } = column;
                if (children) {
                    traverseColumns(children);
                } else {
                    const typeProperty = column.typeProperty || (column.typeProperty = {});
                    typeProperty.canEdit = true;
                    typeProperty.value = data[key];
                }
            });
        }
        traverseColumns(columns);

        return columns;
    }

    confirm = () => {
        const hasWritten = this.formRef.validate();
        if (!hasWritten) return;

        const { data: { investigationId } } = this.state;
        if (sessionStorage.invId != investigationId) {
            this.setState({ loading: true });
            const options = {
                url: API_URL.investigation.getBaseInfo,
                data: { investigationId },
                dataType: 'json',
                doneResult: res => {
                    const { data: { investigationStatus, completeTime, investigationSpecialName } } = res;
                    sessionStorage.invStatus = investigationStatus;
                    sessionStorage.completeTime = completeTime;
                    sessionStorage.invSpecialName = investigationSpecialName;
                    this.setState({ loading: false }, () => {
                        this.doSubmit();
                    });
                },
                errorResult: () => {
                    this.setState({ loading: false })
                },
            };
            $.sendRequest(options);
        } else {
            this.doSubmit();
        }
    }

    render() {
        const { visible, loading } = this.state;
        return (
            <Modal
                title="切换项目\角色\中心"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="create-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="400px"
            >
                <FormList
                    className="form-list"
                    columns={this.getColumns()}
                    onChange={this.handleChange}
                    ref={el => this.formRef = el}
                />
            </Modal>
        );
    }
}

export default SwitchInvestigation;


// WEBPACK FOOTER //
// ./src/components/layout/SwitchInvestigation.js